import L from 'leaflet';

const LINK = Symbol();

L.Control.Camera = L.Control.extend({

    onAdd: function(map) {

        const container = L.DomUtil.create('div', 'leaflet-control-camera leaflet-bar leaflet-control leaflet-font-awesome');

        const link = L.DomUtil.create('a', 'leaflet-bar-part leaflet-bar-part-single', container);

        link.href = '/camera';

        L.DomUtil.create('span', 'fas fa-camera', link);

        if (this.options.onClick) {

            L.DomEvent
                .on(link, 'dblclick', L.DomEvent.stopPropagation)
                .on(link, 'click', L.DomEvent.stopPropagation)
                .on(link, 'click', L.DomEvent.preventDefault)
                .on(link, 'click', this.options.onClick);

            this[LINK] = link;
        }

        return container;
    },

    onRemove: function(map) {

        if (this[LINK])
            L.DomEvent.off(this[LINK], 'click');
    },
});

L.control.camera = (...args) => new L.Control.Camera(...args);



// WEBPACK FOOTER //
// ./src/components/leaflet/L.Control.Camera.js